export const MakeOfferInvalidParametersError: Error = new Error('Invalid parameters for make offer');
export const MakeOfferTokensListError: Error = new Error('Failed to retrieve tokens list from api');
export const MakeOfferAssetError: Error = new Error('Failed to retrieve asset from api');
export const MakeOfferOrderAPIError: Error = new Error('Failed to maker offer in api');
